module.exports = __webpack_public_path__ + "static/scale-model-of-akron-ohio-6c7b14187d10a355dec61a36598cc7b4.png";